import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const { isAuthenticated } = context;

    if (!isAuthenticated) {
      throw redirect({ to: '/auth/login' });
    } else {
      throw redirect({ to: '/dashboard' });
    }
  },
});
